import { Enumify } from 'enumify-ts';
class AustraliaStateType extends Enumify() {
    description;
    static ACT = new AustraliaStateType('Australian Capital Territory');
    static NSW = new AustraliaStateType('New South Wales');
    static NT = new AustraliaStateType('Northern Territory');
    static QLD = new AustraliaStateType('Queensland');
    static SA = new AustraliaStateType('South Australia');
    static TAS = new AustraliaStateType('Tasmania');
    static VIC = new AustraliaStateType('Victoria');
    static WA = new AustraliaStateType('Western Australia');
    static _ = AustraliaStateType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return AustraliaStateType.values.map(it => {
            return {
                label: it.key,
                filter: it.key + ' ' + it.description,
                value: it.key
            };
        });
    }
}
export default AustraliaStateType;
